import { render, staticRenderFns } from "./AnnouncementContent.vue?vue&type=template&id=bee20876&"
import script from "./AnnouncementContent.vue?vue&type=script&lang=js&"
export * from "./AnnouncementContent.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementContent.vue?vue&type=style&index=0&id=bee20876&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports